export { SignInComponent } from './sign-in/sign-in.component';
export { MainComponent } from './main/main.component';
export { DashboardComponent } from './dashboard/dashboard.component';
export { InsightComponent } from './insight/insight.component';
export { InsightDetailComponent } from './insight-detail/insight-detail.component';
export { AlertsComponent } from './alerts/alerts.component';
export { EventsComponent } from './events/events.component';
export { LogsComponent } from './logs/logs.component';
export { UserProfileComponent } from './user-profile/user-profile.component';
export { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
export { CustomerReportComponent } from './customer-report/customer-report.component';
export { CustomerReportMobileComponent } from './customer-report-mobile/customer-report-mobile.component';
export { PageNotFoundComponent } from './page-not-found/page-not-found.component';




// WEBPACK FOOTER //
// /app/src/app/containers/index.ts